module.exports = __webpack_public_path__ + "static/media/coopLogoDashboard.a756f234.png";